module.exports = __webpack_public_path__ + "static/Elys Banner-6686052b5419f3836a064101a59f8125.png";